export default __webpack_public_path__ + "static/media/siyin.7f986695.png";